import { FORM_ADVANCED, FORM_CONFIG } from './FormTemplates'
import Tabs from './Tabs'

export const FORM_LAYOUT = FORM_CONFIG
export const TABS = Tabs
export const ADVANCED_TAB = FORM_ADVANCED
